import { compose, createStore } from "redux";
import { createBrowserHistory } from "history";
import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
// import thunk from "redux-thunk";
import rootReducer from "../reducers";
import createMiddleware from "./middleware";
import localForage from "localforage";

const configureStore = (preloadedState) => {
  const history = createBrowserHistory();

  const persistConfig = {
    key: "empowerEnergy",
    storage: localForage,
    stateReconciler: hardSet,
    whitelist: ["session", "page", "version"], // which reducer to store
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  // Preloaded state should come before middleware
  const store = createStore(
    persistedReducer,
    preloadedState,
    compose(createMiddleware())
  );

  const persistor = persistStore(store);
  // window.addEventListener('storage', crossBrowserListener(store, persistConfig));

  return { history, persistor, store };
};

export default configureStore;
